import React from "react";
import {
  ShieldCheck,
  Target,
  HardHat,
  Sparkles,
  MessageCircle,
  Wrench,
} from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useReveal } from "../hooks/useReveal";

const ICONS = [ShieldCheck, Target, HardHat, Sparkles, MessageCircle, Wrench];
const SECONDARY =
  "https://static.prod-images.emergentagent.com/jobs/1271818a-d288-4bc7-b67d-404fdc5a13fe/images/a889022ea22b0a28830c0305ecf7f6a193a8a980b596ef94d6da1512c702c5af.png";

const Pillar = ({ Icon, title, desc, idx }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`why-pillar-${idx}`}
      style={{ transitionDelay: `${idx * 70}ms` }}
      className="reveal flex gap-5 border-t border-white/10 pt-7"
    >
      <div className="shrink-0 h-12 w-12 flex items-center justify-center bg-zinc-900 border border-sky-400/30 text-sky-400">
        <Icon size={22} strokeWidth={1.5} />
      </div>
      <div>
        <h3 className="font-display font-bold text-white text-lg mb-2">
          {title}
        </h3>
        <p className="text-zinc-400 text-sm leading-relaxed">{desc}</p>
      </div>
    </div>
  );
};

const WhyChooseUs = () => {
  const { t, lang } = useLang();

  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-16 sm:py-24 lg:py-32 bg-zinc-950 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32 space-y-8">
          <div className="flex items-center gap-3">
            <span className="h-px w-12 bg-sky-400"></span>
            <span className="eyebrow">{t.why.eyebrow}</span>
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
            {t.why.title}
          </h2>
          <p className="text-zinc-400 text-base sm:text-lg leading-relaxed max-w-md">
            {t.why.subtitle}
          </p>

          <div className="xa-media-dark relative overflow-hidden border border-white/10">
            <img
              src={SECONDARY}
              alt="Modern pergola"
              className="w-full h-72 object-cover grayscale hover:grayscale-0 transition-all duration-1000"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <div className="eyebrow text-sky-400 mb-1">{lang === "pt" ? "Disponibilidade" : lang === "es" ? "Disponibilidad" : "Availability"}</div>
              <div className="font-display font-bold text-2xl leading-tight">
                {lang === "pt" ? "Confirmada pela equipe" : lang === "es" ? "Confirmada por el equipo" : "Confirmed by our team"}
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-10">
          {t.why.items.map((p, i) => (
            <Pillar
              key={i}
              idx={i}
              Icon={ICONS[i]}
              title={p.title}
              desc={p.desc}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
